import posthog from 'posthog-js'

const posthogKey = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST

if (!posthogKey) {
  console.error('VITE_REACT_APP_PUBLIC_POSTHOG_KEY is not set')
}

if (!posthogHost) {
  console.error('VITE_REACT_APP_PUBLIC_POSTHOG_HOST is not set')
}

posthog.init(posthogKey, {
  api_host: posthogHost,
  autocapture: false,
})

export default posthog
